import { BASE_URL, BUSINESS_NAME } from "@/core/constants/business";

export const META = {
  title: `Premium Cannabis Products | ${BUSINESS_NAME}`,
  meta_description:
    "Explore our premium cannabis products including flower, vape cartridges, edibles, and concentrates at Street Lawyer Services. High-quality cannabis for adult consumers in Washington DC.",
  canonicalUrl: "/products",
  keywords:
    "cannabis products, marijuana dispensary DC, premium flower, vape cartridges, cannabis edibles, thc concentrates, Street Lawyer Services products, weed dispensary Washington DC",
};

export const generateProductsRichSnippet = () => {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Premium Flower",
        description:
          "Hand-selected strains with exceptional aroma, flavor profiles, and effects",
        url: `${BASE_URL}/products/flower`,
        image: `${BASE_URL}/images/kief-infused-joints-inside-dispensary.jpg`,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Vape Cartridges",
        description:
          "Convenient, discreet, and potent cannabis oil cartridges in various formulations",
        url: `${BASE_URL}/products/vape-carts`,
        image: `${BASE_URL}/images/vape-cartridges.jpg`,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Edibles",
        description:
          "Delicious cannabis-infused treats offering precise dosing and long-lasting effects",
        url: `${BASE_URL}/products/edibles`,
        image: `${BASE_URL}/images/edibles.jpg`,
      },
      {
        "@type": "ListItem",
        position: 4,
        name: "Concentrates",
        description:
          "Potent cannabis extracts for experienced consumers seeking maximum THC content",
        url: `${BASE_URL}/products/concentrates`,
        image: `${BASE_URL}/images/variations-of-thc-concentrates.gif`,
      },
    ],
  };
};
